import RatingUpdateBadge from 'components/Dashboard/PriorityUpdates/RatingUpdateBadge';
import TransformFromPascalCase from 'components/Settings/Utilities/TransformFromPascalCase';
import React from 'react';
import { Link } from 'react-router-dom';

export const ListItemLink = ({
  to,
  className = 'content-item-link',
  style,
  onClick,
  tooltipText,
  children,
  ...linkProps
}) => {
  return (
    <Link
      to={to}
      className={className}
      style={style}
      onClick={onClick}
      data-tooltip-content={tooltipText}
      data-tooltip-id='general-tooltip'
      data-tooltip-class-name='header-tooltip'
      data-tooltip-place='top'
      {...linkProps}
    >
      {children}
    </Link>
  );
};

export const ListItemContainer = ({
  as: Container = 'li',
  className = '',
  style,
  unseen = false,
  header = null,
  footer = null,
  children,
}) => {
  return (
    <Container className={className} style={style}>
      {unseen && <span className='unseen-dot' />}
      {header}
      {children}
      {footer}
    </Container>
  );
};

export const ListItemContent = ({ className = 'px-4 py-3', children }) => {
  return <div className={className}>{children}</div>;
};

export const ListItemHeader = ({ className = '', mainContent, actions }) => {
  return (
    <div className={`d-flex align-items-baseline ${className}`}>
      <div className='flex-grow-1'>{mainContent}</div>
      {actions}
    </div>
  );
};

export const ItemControllerActions = ({
  className = 'flex-centered',
  priorityBadge,
  actions,
  rateUpdatesMode,
  ratingFeedback,
}) => {
  if (!priorityBadge && !actions) {
    return null;
  }

  return (
    <div className={className}>
      {rateUpdatesMode ? (
        <>{ratingFeedback && <RatingUpdateBadge item={{ rating: TransformFromPascalCase(ratingFeedback) }} />}</>
      ) : (
        <>
          {priorityBadge}
          {actions}
        </>
      )}
    </div>
  );
};

export const ListItemHighlightSection = ({ show, bodyRef, contributorName, bodyMarkup, tags }) => {
  if (!show) {
    return null;
  }

  return (
    <div className='row mx-0'>
      <div className='legislation-title w-100 px-0'>
        <p className='title-body mt-2 mb-0 position-relative' ref={bodyRef}>
          {!!contributorName && <strong>{contributorName}: </strong>}
          <span dangerouslySetInnerHTML={bodyMarkup} />
        </p>
        {tags}
      </div>
    </div>
  );
};
